import React, { useRef } from "react";
import { Box } from '@curves/ui-base';
import useEChart from "@Util/hook/useEChart";
import { adaptPie } from "@Local/Dashboard/dashboard.util";
import { MAIN_COLOR_PALETTE } from "@Local/Dashboard/dashboard.config";

/********* 會員管道來源 *********/
const MeasurePieBodyCompositionDistributionChart = React.forwardRef((props, ref) => {
    const chartDomRef = useRef(null);
    const { sourceData, weight } = props;

    const { xAxis, data: values } = sourceData;
    const data = adaptPie(xAxis, values[0]);
    const isLoading = data.length === 0;

    const option = {
        // title: {
        //     text: title,
        //     left: 24,
        //     top: 20,
        //     textStyle: {
        //         fontSize: 20,
        //         fontWeight: 600,
        //         color: "#1F2937",
        //     },
        // },

        tooltip: {
            trigger: "item",
            formatter: (params) => {
                return `${params.marker}
                <strong>${params.name}</strong><br/>
                ${params.value} kg (${params.percent}%)`;
            }
        },

        color: MAIN_COLOR_PALETTE,

        graphic: [
            {
                type: "text",
                left: "center",
                top: "38%",
                style: {
                    text: "體重",
                    fill: "#94A3B8",
                    fontSize: 14,
                    textAlign: "center",
                },
            },
            {
                type: "text",
                left: "center",
                top: "43%",
                style: {
                    text: `{value|${Number(weight.toFixed(1))}}\n{unit| kg}`,
                    textAlign: "center",
                    rich: {
                        value: {
                            fill: "#4C0073",
                            fontSize: 52,
                            fontWeight: 700,
                        },
                        unit: {
                            fill: "#4C0073",
                            fontSize: 16,
                            fontWeight: 600,
                        },
                    },
                },
            },
        ],

        series: [
            {
                name: 'Measure Trend',
                type: "pie",
                radius: ["38%", "60%"],
                center: ["50%", "50%"],
                padAngle: 3,
                avoidLabelOverlap: true,
                label: {
                    edgeDistance: 15,
                    minMargin: 5,
                    lineHeight: 18,
                    formatter: '{name|{b}}\n{percent|{d}%}',
                    rich: {
                        name: {
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#111827"
                        },
                        percent: {
                            fontSize: 12,
                            color: "#9CA3AF",
                        }
                    }
                },
                labelLine: {
                    length: 15,
                    length2: 10,
                    maxSurfaceAngle: 80,
                },
                itemStyle: {
                    borderRadius: 4,
                    borderColor: "#fff",
                    borderWidth: 2
                },
                data: data,
            },
        ],
    };

    useEChart(chartDomRef, option);

    return (
        <Box style={{ width: "100%", height: "100%" }}>
            {!isLoading && <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
        </Box>
    );
});

export default MeasurePieBodyCompositionDistributionChart;
